import { render, staticRenderFns } from "./account-patch-password.vue?vue&type=template&id=38567f54&"
import script from "./account-patch-password.vue?vue&type=script&lang=js&"
export * from "./account-patch-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports